import { render } from "./zsActivitySignCheck.vue?vue&type=template&id=058d2d41&scoped=true"
import script from "./zsActivitySignCheck.vue?vue&type=script&lang=js"
export * from "./zsActivitySignCheck.vue?vue&type=script&lang=js"

import "./zsActivitySignCheck.vue?vue&type=style&index=0&id=058d2d41&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058d2d41"]])

export default __exports__